var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H24C32.8366 0 40 7.16344 40 16V24C40 32.8366 32.8366 40 24 40H16C7.16344 40 0 32.8366 0 24V16Z",
    fill: "#F2F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 14C23.75 14.9946 23.3549 15.9484 22.6516 16.6517C21.9484 17.3549 20.9945 17.75 20 17.75C19.0054 17.75 18.0516 17.3549 17.3483 16.6517C16.6451 15.9484 16.25 14.9946 16.25 14C16.25 13.0054 16.6451 12.0516 17.3483 11.3483C18.0516 10.6451 19.0054 10.25 20 10.25C20.9945 10.25 21.9484 10.6451 22.6516 11.3483C23.3549 12.0516 23.75 13.0054 23.75 14ZM12.501 28.118C12.5331 26.1504 13.3373 24.2742 14.7402 22.894C16.143 21.5139 18.0321 20.7405 20 20.7405C21.9679 20.7405 23.857 21.5139 25.2598 22.894C26.6626 24.2742 27.4668 26.1504 27.499 28.118C25.1464 29.1968 22.5881 29.7535 20 29.75C17.324 29.75 14.784 29.166 12.501 28.118Z",
    stroke: "#525355",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilled);
export default __webpack_public_path__ + "static/media/profileFilled.623816840dcc402f7cef8f533f95d69e.svg";
export { ForwardRef as ReactComponent };